(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-role="experts-swiper"]').forEach(function (el) {
      if (!window.Swiper) return;

      var autoplayEnabled = el.getAttribute('data-autoplay') === 'true';
      var delay = parseInt(el.getAttribute('data-delay'), 10) || 7000;
      var loop = el.getAttribute('data-loop') === 'true';

      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 24,
        autoHeight: true,
        loop: loop,
        grabCursor: true,
        simulateTouch: true,
        keyboard: { enabled: true },
        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
        autoplay: autoplayEnabled ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        breakpoints: {
          768: { spaceBetween: 24 }
        }
      });
    });
  });
})();
